import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p446762106731188224',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
